import { render, staticRenderFns } from "./modal-narradores.vue?vue&type=template&id=8b217246&scoped=true&"
import script from "./modal-narradores.vue?vue&type=script&lang=js&"
export * from "./modal-narradores.vue?vue&type=script&lang=js&"
import style0 from "./modal-narradores.vue?vue&type=style&index=0&id=8b217246&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b217246",
  null
  
)

export default component.exports